import React from 'react';
import { Container, Typography, Box, Paper, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import ThemeDemo from '../../components/store/ThemeDemo';
import { useStoreSettings } from '../../contexts/StoreSettingsContext';

const ThemeDemoPage: React.FC = () => {
  const { settings } = useStoreSettings();
  const activeTheme = settings?.display?.theme || 'default';

  return (
    <Container maxWidth="lg">
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          معاينة الثيم
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" paragraph>
          الثيم الحالي: <strong>{activeTheme}</strong>
        </Typography>
        <Typography variant="body1" paragraph>
          هذه الصفحة تعرض كيفية تطبيق الثيم الحالي على مكونات المتجر المختلفة. يمكنك تغيير الثيم من إعدادات العرض.
        </Typography>
        <Box sx={{ mb: 2 }}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/store-settings/display"
            sx={{ mr: 2 }}
          >
            تغيير الثيم
          </Button>
          <Button
            variant="outlined"
            component={Link}
            to="/store"
          >
            العودة للمتجر
          </Button>
        </Box>
      </Paper>

      <ThemeDemo />
    </Container>
  );
};

export default ThemeDemoPage;
